var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{ref:"type",class:( _obj = {}, _obj[_vm.animationClass] = _vm.animationTrigger, _obj[_vm.iconClass] = true, _obj ),attrs:{"src":_vm.iconSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }